<template lang="html">
  <div class="card-member">
    <div class="image">
      <img :src="imageURL" alt="image" />
    </div>
    <div class="content">
      <h6 class="title">{{ title }}</h6>
      <p class="description">{{ description }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imageURL: String,
    title: String,
    description: String,
  },
};
</script>
<style lang="css" scoped>
.card-member {
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  cursor: pointer;
}

.card-member .image {
  min-width: 140px;
  width: 140px;
  height: 140px;
  border-radius: 100%;
  background: #d4ebf7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  transition: all 0.3s ease-in-out;
}

.card-member .image img {
  width: 80%;
}
.card-member .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: #33647e;
  margin-bottom: 10px;
}
.card-member .content .description {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 23px;
  color: #999696;
  margin-bottom: 0;
}

@media (max-width: 500px) {
  .card-member {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .card-member .image {
    margin-bottom: 16px;
  }
  .card-member .content .title {
    text-align: center;
    font-weight: 500;
  }
  .card-member .content .description {
    text-align: center;
    font-size: 16px;
    line-height: 19px;
  }
}
</style>
